import { MaskedHeading, Rise } from "@/components/Motion";
import { ApplyBanner } from "@/pages/TherapyPage";

export default function PlaceholderPage({ eyebrow, title }) {
  return (
    <main data-testid="placeholder-page">
      <section className="px-6 sm:px-10 lg:px-14 pt-20 lg:pt-28">
        <div className="max-w-7xl mx-auto">
          <Rise><div className="kh-eyebrow mb-6">{eyebrow}</div></Rise>
          <MaskedHeading text={title} className="kh-serif text-5xl sm:text-6xl lg:text-7xl leading-[1] max-w-4xl" />
          <Rise delay={0.6}><p className="mt-6 text-lg max-w-2xl" style={{ color: "var(--kh-text-muted)" }}>This page is coming soon.</p></Rise>
        </div>
      </section>
      <ApplyBanner />
    </main>
  );
}
